import {Component, EventEmitter, Input, OnDestroy, Output} from '@angular/core';
import {Returns} from "../../../interfaces/orders-history";
import {ReturnGoods} from "../../../interfaces/return-goods";
import {takeUntil} from "rxjs/operators";
import {BaseService} from "../../../services/base.service";
import {Subject} from "rxjs";
import {HttpClient} from "@angular/common/http";

@Component({
  selector: 'app-modal-order-return',
  templateUrl: './modal-order-return.component.html',
  styleUrls: ['./modal-order-return.component.scss']
})
export class ModalOrderReturnComponent extends BaseService implements OnDestroy {
  @Input()
  returnSelected: Returns;

  @Input()
  returnGoods: ReturnGoods[];

  @Input()
  returns: Returns[];

  @Output()
  setPrintChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  public isDestroyed: Subject<boolean> = new Subject<boolean>();
  public isModalReturnsShow: boolean = false;
  public startPrint: boolean = false;
  public printReturns: boolean = false;
  public isDarkBackground: boolean = false;

  constructor(
    private http: HttpClient
  ) {
    super();
  }

  showModalOrderReturns(returned: Returns) {
    // Модалка відкривається одразу, а дані приходять потім: без скидання при збої запиту
    // (або поки він іде) показувалась і друкувалась попередня заява - номер замовлення й товари.
    this.returnSelected = returned;
    this.returnGoods = [];

    this.http.post(this.apiRoot + 'orders_history/get_return', {
      order_id: returned.order_id,
      return_id: returned.id
    })
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((data: ReturnGoods[]) => {
        // пізня відповідь по раніше відкритій заяві не перезаписує поточну
        if (this.returnSelected !== returned) {
          return;
        }

        // порожню вибірку бек віддає як 0 (заяву вже проведено/видалено) - for...of по 0 падав
        this.returnGoods = Array.isArray(data) ? data : [];

        for (let returnGood of this.returnGoods) {
          if (returnGood.artikul === null) {
            returnGood.artikul = '';
          } else if (typeof returnGood.artikul === "number") {
            returnGood.firstArticle = returnGood.artikul;
          } else {
            returnGood.firstArticle = returnGood.artikul.split('|||')[0];
          }
        }
      });

    this.isModalReturnsShow = true;
    this.isDarkBackground = true;
  }

  printReturn() {
    this.setPrintChange.emit();
    this.printReturns = true;
    this.startPrint = true;

    setTimeout(() => {
      window.print();

      this.startPrint = false;
      this.printReturns = false;
    }, 0);

  }

  closeModal() {
    this.isModalReturnsShow = false;
    this.isDarkBackground = false;
  }

  ngOnDestroy() {
    this.isDestroyed.next(true);
    this.isDestroyed.complete();
  }
}
